import React from "react"

const OrderProgressiveLoading = () => {
  return (
    <div className="order-list">
      <div className="order-list__header">
        <div className="order-list__title width-full">
          <p className="shimmer-loading__title shimmer height-60"></p>
        </div>
      </div>

      <div className="order-tile">
        <div className="order-tile__order-no">
          <p className="shimmer-loading__para30 shimmer width-170"></p>
        </div>
        <div className="order-tile__details">
          <section className="order-tile__date">
            <div className="order-tile__label">
              <p className="shimmer-loading__para30 shimmer width-170"></p>
            </div>
            <div className="order-tile__value">
              <p className="shimmer-loading__para30 shimmer width-170"></p>
            </div>
          </section>
          <section className="order-tile__items">
            <div className="order-tile__label">
              <p className="shimmer-loading__para30 shimmer width-80"></p>
            </div>
            <div className="order-tile__value">
              <p className="shimmer-loading__para30 shimmer width-80"></p>
            </div>
          </section>
          <section className="order-tile__total">
            <div className="order-tile__label">
              <p className="shimmer-loading__para30 shimmer width-170"></p>
            </div>
            <div className="order-tile__value">
              <span>
                <p className="shimmer-loading__para30 shimmer width-170"></p>
              </span>
            </div>
          </section>
          <section className="order-tile__status">
            <div className="order-tile__label">
              <p className="shimmer-loading__para30 shimmer width-170"></p>
            </div>
            <div className="order-tile__value">
              <p className="shimmer-loading__para30 shimmer width-170"></p>
            </div>
          </section>
        </div>
        <p className="shimmer-loading__para30 shimmer width-170"></p>
      </div>

      <div className="order-tile">
        <div className="order-tile__order-no">
          <p className="shimmer-loading__para30 shimmer width-170"></p>
        </div>
        <div className="order-tile__details">
          <section className="order-tile__date">
            <div className="order-tile__label">
              <p className="shimmer-loading__para30 shimmer width-170"></p>
            </div>
            <div className="order-tile__value">
              <p className="shimmer-loading__para30 shimmer width-170"></p>
            </div>
          </section>
          <section className="order-tile__items">
            <div className="order-tile__label">
              <p className="shimmer-loading__para30 shimmer width-80"></p>
            </div>
            <div className="order-tile__value">
              <p className="shimmer-loading__para30 shimmer width-80"></p>
            </div>
          </section>
          <section className="order-tile__total">
            <div className="order-tile__label">
              <p className="shimmer-loading__para30 shimmer width-170"></p>
            </div>
            <div className="order-tile__value">
              <span>
                <p className="shimmer-loading__para30 shimmer width-170"></p>
              </span>
            </div>
          </section>
          <section className="order-tile__status">
            <div className="order-tile__label">
              <p className="shimmer-loading__para30 shimmer width-170"></p>
            </div>
            <div className="order-tile__value">
              <p className="shimmer-loading__para30 shimmer width-170"></p>
            </div>
          </section>
        </div>
        <p className="shimmer-loading__para30 shimmer width-170"></p>
      </div>
    </div>
  )
}

export default OrderProgressiveLoading
